import { ABExperimentVariant } from '@models/abTest/experiment';

export const getExperimentVariant = (userHash: string, variants: ABExperimentVariant[]): ABExperimentVariant | null => {
  if (variants.length === 0) return null;
  if (variants.length === 1) return variants[0];
  const hashConverted = BigInt(`0x${userHash}`);
  const variantIndex = Number(hashConverted % 100n);
  let percentage: number = 0;
  let selectedVariant: ABExperimentVariant = variants[0];
  for (const v of variants) {
    percentage += v.percentage;
    if (variantIndex < percentage) {
      selectedVariant = v;
      break;
    }
  }
  return selectedVariant;
};
